module.exports = __webpack_public_path__ + "i18n/angular-locale_es-mx.js";